<template>
  <div
      class="my-2 col-6 col-sm-4 col-md-3 col-xl-2">
    <div
      class="card shadow-sm h-100 animate__animated animate__fadeIn animate__faster"
      style="min-height: 9em;">
      <img class="card-img-top">
      <div class="card-body d-flex align-items-center justify-content-center position-relative p-4">
        <!-- <span
          v-if="mfg.super_buyline"
          class="badge bg-danger super-badge">
          (3) Brands
        </span> -->
        <span
          class="badge bg-info info shadow-sm"
          data-bs-toggle="modal"
          data-bs-target="#dropshipDetail"
          @click="setModalMfg">
          <i class="fa fa-info-circle"/>
          More Info
        </span>
        <h5
          class="card-title mfg text-center"
          style="cursor: pointer;"
          @click="browse(mfg)">
          <img
            :src="mfg.super_buyline ? mfg.logo2 : mfg.logo"
            class="img-fluid"
            style="max-height: 8em;">
          </h5>
        </div>
      <div
        class="card-footer text-center"
        style="cursor: pointer;"
        @click="browse(mfg)">
        {{ mfg.super_buyline ? mfg.super_buyline_name || mfg.mfg :  mfg.mfg }}
      </div>
    </div>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';

  // Initialize
  const props = defineProps(['mfg'])
  const store = useStore()

  // Methods
  const setModalMfg = ()=>{
    store.dispatch('setDropshipMfg', {mfg: props.mfg, modal: true})
  }

  const browse = (mfg)=>{
    store.dispatch('setDropshipMfg', {mfg, modal: false})
  }

</script>

<style scoped>
  .info{
    position: absolute;
    top: -3px;
    right: -3px;
    cursor: pointer;
  }
  .super-badge{
    position: absolute;
    top: -3px;
    left: -3px;
  }
  .times{
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
  }
  .info:hover{
    scale: 1.1;
    transition: all 50ms ease-in;
  }
  .mfg:hover{
    scale: 1.05;
    transition: all 50ms ease-in;
  }
</style>